import 'jquery'
import 'slick-carousel'

// Import everything from autoload
import './autoload/_bootstrap.js'

import * as Func from './func'

// Load Events
$(document).ready(() => {
  Func.handleToggleMobileTopMenu()
  Func.handleToggle()
  Func.createCOISlider()
  Func.createNewsFeatureSlider()
  Func.handleToggleFilterGroup()
})



// WEBPACK FOOTER //
// ./scripts/main.js